<style lang="scss" scoped>
@screen mobile {
  .office-select-header {
    @apply w-full;
    &__wrapper {
      @apply m-0 px-4;
    }
    &__list {
      &-item {
        @apply text-sm p-4 #{!important};
      }
    }
  }
}
</style>

<template>
  <transition name="fade">
    <section
      v-show="isCurrentOffice"
      class="office-select-header"
    >
      <div
        v-click-outside="() => showList = false"
        :class="[
          isSelect && 'office-select-header__wrapper--is-select',
          showList && 'office-select-header__wrapper--selected'
        ]"
        class="office-select-header__wrapper"
        @click="showList = !showList"
      >
        <div class="office-select-header__selected">
          {{ currentOffice.name }}
        </div>

        <dr-icon
          v-show="isSelect"
          name="changeOffice"
          color="transparent"
          fill="transparent"
          class="office-select-header__icon"
        />

        <transition name="fade">
          <ul
            v-show="showList"
            class="office-select-header__list"
          >
            <li
              v-for="office in offices"
              :key="`header-select-office-${office.id}`"
              :class="(office.id === currentOffice.id) && 'office-select-header__list-item--selected'"
              class="office-select-header__list-item"
              @click="setOffice(office.id)"
            >
              <span>{{ office.name }}</span>

              <i
                v-if="office.id === currentOffice.id"
                class="icon icon-check"
              />
            </li>
          </ul>
        </transition>
      </div>
    </section>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DrOfficeSelect',

  data () {
    return {
      showList: false
    }
  },

  computed: {
    ...mapGetters({
      offices: 'getOffices',
      currentOffice: 'getCurrentOffice'
    }),

    isSelect () {
      return !!this.offices.length
    },

    isCurrentOffice () {
      if (this.currentOffice) {
        return !!Object.keys(this.currentOffice || {}).length
      }

      return false
    },

    maxWidth () {
      return this.offices
        .map(o => String(o.name).length)
        .sort((a, b) => a + b)[0]
    }
  },

  methods: {
    setOffice (id) {
      if (id && id !== this.currentOffice.id) {
        this.$store.dispatch('setCurrentOffice', id)
        localStorage.setItem('sessionOfficeId', id)
      }
    }
  }
}
</script>
